export enum Breakpoint {
  ZOOM_400 = 320,
  EXTRA_SMALL = 480,
  SMALL = 576,
  MEDIUM = 768,
  LARGE = 992,
  EXTRA_LARGE = 1200,
}
